import { BreadcrumbsProps, default as MuiBreadcrumbs } from '@mui/material/Breadcrumbs'
import * as React from 'react'

export const Breadcrumbs: React.FC<React.PropsWithChildren<BreadcrumbsProps>> = (props) => {
  return <MuiBreadcrumbs {...props} />
}

export default Breadcrumbs
